import { filter, get } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Table } from 'react-bootstrap'
import { Badge } from 'reactstrap'

import Button from '../../Button'
import { TOrder } from '../helpers'
import Cancelation from './Cancelation'

type TColiTable = {
  order: TOrder
  cancelColi: (id?: string) => void
  isCron?: boolean
}

// TODO: use Real Coli types
const ColiTable = (props: TColiTable): React.ReactElement => {
  const { order, cancelColi, isCron = false } = props

  const cancelledColis = filter(
    get(order, ['execution_order', 0, 'colis'], []),
    (coli) => get(coli, 'state.storniert'),
  )
  const cancelledColiIds = cancelledColis.map((coli) => get(coli, 'barcode1'))

  return (
    <Table size="sm" striped bordered responsive>
      <tbody>
        <tr>
          <th />
          <th>{i18n.t('weight_in_kg', 'Gewicht in kg')}</th>
          <th>{i18n.t('size_l_w_h', 'Größe (LxHxB)')}</th>
          <th>{i18n.t('coliReference', 'Colireferenz')}</th>
          {!isCron && <th>{i18n.t('barcode', 'Barcode')}</th>}
          {!get(order.slaObject, 'isPickup', false) && (
            <>
              {' '}
              <th>{i18n.t('pickup_time', 'Abholzeit')}</th>
              <th>{i18n.t('delivery_time', 'Zustellzeit')}</th>
            </>
          )}
          {!isCron && <th />}
        </tr>

        {order.colis.map((coli, index) => {
          const isCancelled = cancelledColiIds.includes(get(coli, 'barcode1'))
          const cancelComponents: React.ReactElement[] = []

          if (isCancelled)
            cancelComponents.push(
              <Badge color="danger">{i18n.t('cancelled', 'Storniert')}</Badge>,
            )

          if (coli.cancelAllowed && !isCancelled)
            cancelComponents.push(
              <Cancelation id={String(coli.id)} cancelColi={cancelColi} />,
            )

          if (!coli.cancelAllowed && !isCancelled)
            cancelComponents.push(
              <Button
                style={{ color: '#fff' }}
                className={`text-center btn-dark `}
                disabled
                icon="far fa-ban"
              >
                {i18n.t('unable_cancel_order2', 'Stornierung nicht möglich')}
              </Button>,
            )
          return (
            <tr key={index}>
              <td>
                <i className="fas fa-cube" />
                {` #${index + 1}`}
              </td>
              <td>{get(coli, 'weight', 0)}</td>
              <td>
                {get(coli, 'length', 0)} cm x {get(coli, 'width', 0)} cm x{' '}
                {get(coli, 'height', 0)} cm
              </td>

              <td>
                {get(coli, 'coliCustomerReference') === null
                  ? '-'
                  : get(coli, 'coliCustomerReference')}
              </td>

              {!isCron && <td>{get(coli, 'barcode1', '-')}</td>}

              {!get(order.slaObject, 'isPickup', false) && (
                <>
                  {' '}
                  <td>
                    {isCron ? (
                      `${i18n.t('respectivley', 'Jeweils')} ${moment(
                        order.pickupTimeFrom,
                      ).format('HH:mm')} ${i18n.t(
                        'until_lowercase',
                        'bis',
                      )} ${moment(order.pickupTimeUntil).format('HH:mm')}`
                    ) : (
                      <>
                        {`${moment(order.pickupTimeFrom).format(
                          'DD.MM.YYYY HH:mm',
                        )}`}{' '}
                        {i18n.t('until_lowercase', 'bis')} <br />
                        {`${moment(order.pickupTimeUntil).format(
                          'DD.MM.YYYY HH:mm',
                        )}`}
                      </>
                    )}
                  </td>
                  <td>
                    {isCron ? (
                      `${i18n.t('respectivley', 'Jeweils')} ${moment(
                        order.deliveryTimeFrom,
                      ).format('HH:mm')} ${i18n.t(
                        'until_lowercase',
                        'bis',
                      )} ${moment(order.deliveryTimeUntil).format('HH:mm')}`
                    ) : (
                      <>
                        {`${moment(order.deliveryTimeFrom).format(
                          'DD.MM.YYYY HH:mm',
                        )}`}{' '}
                        {i18n.t('until_lowercase', 'bis')} <br />
                        {`${moment(order.deliveryTimeUntil).format(
                          'DD.MM.YYYY HH:mm',
                        )}`}
                      </>
                    )}
                  </td>
                </>
              )}
              {!isCron && <td align="right">{cancelComponents}</td>}
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}

export default ColiTable
